import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import QRCode from "qrcode";

const QRCodeDisplay = ({ value, size = 128 }) => {
  const [dataUrl, setDataUrl] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!value) {
      setDataUrl("");
      return;
    }

    let active = true;
    setLoading(true);
    QRCode.toDataURL(String(value), {
      width: size,
      margin: 1,
      color: { dark: "#0f172a", light: "#ffffff" },
    })
      .then((url) => {
        if (active) setDataUrl(url);
      })
      .catch(() => {
        if (active) setDataUrl("");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [value, size]);

  if (!value) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  if (loading && !dataUrl) {
    return <CircularProgress size={24} />;
  }

  if (!dataUrl) return null;

  return (
    <Box
      sx={{
        display: "inline-flex",
        bgcolor: "#fff",
        borderRadius: 1,
        p: 0.5,
        border: "1px solid rgba(15,23,42,0.08)",
      }}
    >
      <img
        src={dataUrl}
        alt={`QR ${value}`}
        width={size}
        height={size}
        style={{ display: "block" }}
      />
    </Box>
  );
};

export default QRCodeDisplay;
